import React, { useMemo } from 'react'

import NameStep from '../../Steps/NameStep'
import FileUploadStep from '../../Steps/FileUploadStep'
import StepForm from '../../../../../../../features/components/Forms/StepForm'

import { useCreateGamAd } from '../../hooks/useCreateGamAd'

import { AD_TYPE_IMAGE, IMAGE_UPLOAD_TYPE } from '../../fields'

const UploadImageCreativeRoute = ({ FormRouteSelector, isInternalAdCreation, ...formProps }) => {
  const { purifiedFormik } = useCreateGamAd({
    isInternalAdCreation,
    formatOption: IMAGE_UPLOAD_TYPE
  })

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: <NameStep />,
        show: true
      },
      {
        component: <FileUploadStep adType={AD_TYPE_IMAGE} />,
        show: true
      }
    ],
    [FormRouteSelector]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} />
}

export default UploadImageCreativeRoute
